<script setup lang="ts">
import {
	DropdownMenuItem,
	useForwardPropsEmits,
	type DropdownMenuItemEmits,
	type DropdownMenuItemProps,
} from "reka-ui";
import { useDelegatedProps, type ClassProps } from "../../lib/base-props";

defineOptions({ inheritAttrs: false });

interface Props extends Omit<DropdownMenuItemProps, "as" | "asChild">, ClassProps {}

const props = defineProps<Props>();
const emit = defineEmits<DropdownMenuItemEmits>();

const delegatedProps = useDelegatedProps(props);

const forwarded = useForwardPropsEmits(delegatedProps, emit);
</script>

<template>
	<DropdownMenuItem as="li" v-bind="forwarded">
		<div :class="props.class">
			<slot />
		</div>
	</DropdownMenuItem>
</template>
